export default {
  getAttainmentsMes() {
    return this.http('api', 'get', '/app-interface/v1/attainments');
  },
  getAttainmentsDetail(params) {
    return this.http('api', 'get', '/app-interface/v1/attainment', params);
  }
};
